import palette from '../palette';

export default {
  iconButton: {
    color: palette.secondary.main,
  },
};
